
import {render} from 'react-dom';

import App from '@/pages/_app';

render(
    <App />,
    document.getElementById('root')
);
